export enum Sort {
	Asc,
	Desc,
	None
}

export enum OperationMode {
	None,
	Duplicates,
	PullTracks
}
